import { render, staticRenderFns } from "./UserContent.vue?vue&type=template&id=b3ec82e4&"
import script from "./UserContent.vue?vue&type=script&lang=ts&"
export * from "./UserContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports